import classNames from 'classnames';

import { BoxProps } from '@project44/manifest-ui-deprecated';

import { ChildrenType } from '../../definitions/types/Children';

import { Wrap } from './styles';

interface ICollapsibleProps extends BoxProps {
  active?: boolean;
  children?: ChildrenType;
  width?: number;
  'data-testid'?: string;
}

export const Collapsible = ({
  active = false,
  width,
  children,
  'data-testid': dataTestid,
}: ICollapsibleProps) => {
  const classActive = classNames({
    'collapsible-active': active,
    collapse: true,
  });
  return (
    <Wrap
      className={classActive}
      data-testid={dataTestid || 'collapsible'}
      expandedwidth={width}
    >
      {children}
    </Wrap>
  );
};
